import React, {Component} from 'react';
const { Link } = require('react-router');
import {t} from 'l10n'

import Registry from 'registry';

import '../../sass/member/MemberWishlistBlock.scss';

class MemberWishlistBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        let BOBSTORE_URL = Registry.get('BOBSTORE_URL');

        let {wishlist} = this.props,
            totalCount = wishlist ? wishlist.length : 0;

        return (
            <aside className="wishlist-member">
                <div className="content">
                    <div className="heading">
                        <h2>{t('My wishlist on')} <a href={BOBSTORE_URL} target="_blank">Bobstore</a> <em>{totalCount}</em></h2>
                        <a className="add-item" href={BOBSTORE_URL} target="_blank">{t('Add to wishlist')}</a>
                    </div>
                    <div className="list-wishlist-main ui-responsive-grid">
                        {wishlist && wishlist.map((item, index) =>
                            <div key={index}>
                                <div className="list-wishlist-main-item">
                                    <div className="img">
                                        <img src={item.thumbnail_url} alt="" />
                                    </div>
                                    <div className="text">
                                        <p className="name-wishlist">
                                            <a href={item.url} target="_blank">{item.title}</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="view-all-placehoder"></div>
                </div>
            </aside>
        )
    }
}

export default MemberWishlistBlock;


// WEBPACK FOOTER //
// ./src/components/member/MemberWishlistBlock.js